export default "__VITE_ASSET__C3nw7oXC__"